import { render } from "./SkeletonMiniWizardSticky.vue?vue&type=template&id=714c4710"
import script from "./SkeletonMiniWizardSticky.vue?vue&type=script&lang=js"
export * from "./SkeletonMiniWizardSticky.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__